export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export interface NotificationState {
  isVisible: boolean
  message: string
  duration: number
  type: NotificationType
}

export interface NotificationContextType {
  notification: NotificationState
  openNotification: (message: string, type: NotificationType) => void
  closeNotification: () => void
}
